module.exports = __webpack_public_path__ + "static/media/icon_media.f142b5cc.svg";